import axios from "axios";

export const BASE_API = '/soldrax_app/api/';
//export const BASE_API = 'github_projects/soldrax/api/';

export const GAME_SERVER = 'https://soldrax.werenium.com/game-server/';
//export const GAME_SERVER = 'game-server/';

export const WEB_SOCKET_URL = "wss://soldrax.werenium.com/";
//export const WEB_SOCKET_URL = "ws://192.168.159.36:8000";

export function callBaseApi (url, params) {
  return new Promise(async resolve => {
    //call main api
    let formData = new FormData();
    for (let key in params) {
      formData.append(key, params[key]);
    }

    axios.post(BASE_API+url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(response => {
      //console.log(url);
      console.log(response.data);
      resolve(response.data);
    }).catch(error => {
      resolve({
        status: 0,
        msg: "Network Connection Error",
      })
    })
  })
}

export function callApi (url, params) {
  return new Promise(async resolve => {
    //call main api
    let formData = new FormData();
    for (let key in params) {
      formData.append(key, params[key]);
    }

    axios.post(GAME_SERVER+url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(response => {
      console.log(url)
      console.log(response.data);
      resolve(response.data);
    }).catch(error => {
      resolve({
        status: 0,
        msg: "Network Connection Error",
      })
    })
    //..
    
  })
}

export function generateRandomString(length = 6) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
}

export function getInlineLoader (type) {
  return (
    <div className="CoreLoader" data-type={type}>
    </div>
  );
}

export function processTimer(gameData, currentServerTimestamp) {
  
  let timerDiff = Number(gameData.sessionTimer) - (currentServerTimestamp || gameData.currentServerTimestamp);
  if(timerDiff > 0) {
    let minutes = Math.trunc(timerDiff/60);
    let seconds = Math.trunc(timerDiff % 60);
    if(seconds < 10) {
      seconds = "0"+String(seconds);
    }

    if(minutes < 10) {
      minutes = "0"+String(minutes);
    }

    return (String(minutes)+":"+String(seconds))

  } else {
    return "00:00";
  }
}